// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';
import LicenseCheckerConstants from 'logic/data/Izenda.LicenseCheckerConstants';

const SECTION = {
  SystemConfiguration: 'systemConfiguration',
  TenantSetup: 'tenantSetup',
  DataSetup: 'dataSetup',
  UserSetup: 'userSetup',
  RoleSetup: 'roleSetup',
  Reports: 'reports',
  Dashboards: 'dashboards',
  Access: 'access',
  Scheduling: 'scheduling',
  Emailing: 'emailing',
  Exporting: 'exporting',
  SystemWide: 'systemwide'
};

const SECTION_LIST_FULL_REPORT_DASHBOARD_ACCESS = [
  {
    key: SECTION.SystemConfiguration,
    get value() {
      return localizer.getText('COMMON_LABEL_SYSTEM_CONFIGURATION');
    }
  },
  {
    key: SECTION.TenantSetup,
    get value() {
      return localizer.getText('COMMON_LABEL_TENANT_SETUP');
    },
    alwaysShow: true
  },
  {
    key: SECTION.DataSetup,
    get value() {
      return localizer.getText('COMMON_LABEL_DATA_SETUP');
    }
  },
  {
    key: SECTION.UserSetup,
    get value() {
      return localizer.getText('COMMON_LABEL_USER_SETUP');
    }
  },
  {
    key: SECTION.RoleSetup,
    get value() {
      return localizer.getText('COMMON_LABEL_ROLE_SETUP');
    }
  },
  {
    key: SECTION.SystemWide,
    get value() {
      return localizer.getText('COMMON_LABEL_SYSTEM_WIDE');
    }
  }
];

const SECTION_LIST = [
  {
    key: SECTION.SystemConfiguration,
    get value() {
      return localizer.getText('COMMON_LABEL_SYSTEM_CONFIGURATION');
    },
    licenseKey: 'Scheduling'
  },
  {
    key: SECTION.TenantSetup,
    get value() {
      return localizer.getText('COMMON_LABEL_TENANT_SETUP');
    },
    alwaysShow: true
  },
  {
    key: SECTION.DataSetup,
    get value() {
      return localizer.getText('COMMON_LABEL_DATA_SETUP');
    }
  },
  {
    key: SECTION.UserSetup,
    get value() {
      return localizer.getText('COMMON_LABEL_USER_SETUP');
    }
  },
  {
    key: SECTION.RoleSetup,
    get value() {
      return localizer.getText('COMMON_LABEL_ROLE_SETUP');
    }
  },
  {
    key: SECTION.Reports,
    get value() {
      return localizer.getText('COMMON_LABEL_REPORTS');
    }
  },
  {
    key: SECTION.Dashboards,
    get value() {
      return localizer.getText('COMMON_LABEL_DASHBOARDS');
    },
    licenseKey: 'Dashboard'
  },
  {
    key: SECTION.Access,
    get value() {
      return localizer.getText('COMMON_LABEL_ACCESS');
    }
  },
  {
    key: SECTION.Scheduling,
    get value() {
      return localizer.getText('COMMON_LABEL_SCHEDULING');
    },
    licenseKey: 'Scheduling'
  },
  {
    key: SECTION.Emailing,
    get value() {
      return localizer.getText('COMMON_LABEL_EMAILING');
    }
  },
  {
    key: SECTION.Exporting,
    get value() {
      return localizer.getText('COMMON_LABEL_EXPORTING');
    },
    licenseKey: 'Exporting'
  },
  {
    key: SECTION.SystemWide,
    get value() {
      return localizer.getText('COMMON_LABEL_SYSTEM_WIDE');
    }
  }
];

const CATEGORY_TYPE = {
  REPORT: 0,
  DASHBOARD: 1
};

const ROLE_TYPE = {
  ACCESS: 0,
  SCHEDULE: 1
};

const TREE_TYPE = {
  CATEGORY: 0,
  ACCESS: 1
};

const NUMBER_CATEGORY_TAKE = {
  VISIBLE: 2,
  SAVEABLE: 3
};

const ROLE_PERMISSION_CONCAT_TREE_MAP = [
  {
    prop: 'childNodes',
    nodeType: 'User'
  }
];

const ROLE_PERMISSION_TREE_MAP = [
  {
    prop: 'childNodes',
    nodeType: 'Role',
    expand: true,
    showTotal: true,
    children: ROLE_PERMISSION_CONCAT_TREE_MAP
  }
];

export default {
  SECTION,
  SECTION_LIST,
  SECTION_LIST_FULL_REPORT_DASHBOARD_ACCESS,
  CATEGORY_TYPE,
  ROLE_TYPE,
  TREE_TYPE,
  NUMBER_CATEGORY_TAKE,
  ROLE_PERMISSION_TREE_MAP,
  ROLE_PERMISSION_CONCAT_TREE_MAP,
  ICON_TRIANGLE: {
    ICON_DOWN: 'icon-triangle-down',
    ICON_RIGHT: 'icon-triangle-right'
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.PermissionConstants.js